<template>
    <div class="major_detail_container" v-loading="loading">
        <div class="breadcrumb_box">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/specialized-library/index' }">专业库</el-breadcrumb-item>
                <el-breadcrumb-item>{{ `${detailData.sch_maj_name}(${detailData.school_name})` }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="school_major_info">
            <div class="logo-section">
                <img :src="detailData.school_logo" alt="Logo">
                <div>
                    <span class="school_name">{{ detailData.sch_maj_name + (detailData.sch_maj_ename ? '/' +
        detailData.sch_maj_ename : '') }}</span>
                    <div>
                        <el-link :underline="false" class="e_name" @click="handleToCollege(detailData.school_id)">
                            {{ (detailData.school_name || '暂无') + '/' +
        (detailData.school_ename || '暂无') }}
                            <i class="el-icon-arrow-right"></i>
                        </el-link>
                    </div>
                    <div class="tags">
                        <span class="tag_item" v-for="item in detailData.major_info">{{ item }}</span>
                        <span class="tag_item">{{ detailData.department }}</span>
                    </div>
                    <div class="school_address">
                        <i class="el-icon-map-location"></i>
                        <span class="address_name">{{ detailData.school_city ? detailData.school_country + '/' +
        detailData.school_city : detailData.school_country }}</span>
                        <i style="color: #4678F8;margin-left: 15px;" class="el-icon-link"></i>
                        <span style="color: #4678F8;cursor: pointer;" @click="handleToWebsite">官网地址</span>
                    </div>
                </div>
            </div>
            <div class="rankings-section">
                <div class="ranking-item">
                    <p>{{ detailData.qs_rank || '-' }}</p>
                    <span>2025 QS排名</span>
                </div>
                <div class="ranking-item">
                    <p>{{ detailData.the_rank || '-' }}</p>
                    <span>2025 THE排名</span>
                </div>
                <div class="ranking-item">
                    <p>{{ detailData.us_news_rank || '-' }}</p>
                    <span>2025 U.S.News</span>
                </div>
            </div>
        </div>
        <div class="content">
            <el-tabs v-model="activeName" @tab-click="handleTabClick">
                <el-tab-pane label="专业概况" name="introduction"></el-tab-pane>
                <el-tab-pane label="细分方向" name="direction"></el-tab-pane>
                <el-tab-pane label="要求说明" name="illustrate"></el-tab-pane>
            </el-tabs>
            <div class="scroll_box">
                <div class="title_box">
                    <div class="title_box_content" id="introduce-colleges-content-title">
                        <img src="https://oss.kaoyanvip.cn/attach/file1738981959289.png" alt="">
                        <span>培养目标</span>
                    </div>
                    <div class="text_info">
                        {{ detailData.cultivation_target || '暂无培养目标信息' }}
                    </div>
                </div>
                <div class="title_box">
                    <div class="title_box_content">
                        <img src="https://oss.kaoyanvip.cn/attach/file1738981959289.png" alt="">
                        <span>项目简介</span>
                    </div>
                    <ul class="projectIntroduction">
                        <li><span>专业方向: </span><span>{{ detailData.major_direction || '---' }}</span></li>
                        <li><span>项目类别: </span>
                            <span v-if="detailData.project_type">
                                <span style="margin-right: 5px;color: #303030;">{{ detailData.project_type }}</span>
                                <el-tooltip effect="dark" placement="top">
                                    <div slot="content" style="width: 300px;">{{ detailData.project_type_remark }}</div>
                                    <svg-icon style="cursor: pointer;" icon-class="quession"></svg-icon>
                                </el-tooltip>
                            </span>
                            <span v-else>---</span>
                        </li>
                        <li><span>入学时间: </span><span>{{ detailData.enrollment_time || '---' }}</span></li>
                        <li><span>项目时长: </span><span>{{ detailData.project_duration || '---' }}</span></li>
                        <li><span>项目学费: </span><span>{{ detailData.tuition || '---' }}</span></li>
                        <li><span>项目规模: </span><span>{{ detailData.project_size || '---' }}</span></li>
                        <li><span>平均成绩: </span>
                            <span v-if="detailData.gpa_avg">
                                <span style="margin-right: 5px;color: #303030;">{{ detailData.gpa_avg }}</span>
                                <el-tooltip effect="dark" content="平均录取的GPA分数" placement="top">
                                    <svg-icon style="cursor: pointer;" icon-class="quession"></svg-icon>
                                </el-tooltip>
                            </span>
                            <span v-else>---</span>
                        </li>
                        <li><span>国际学生: </span><span>{{ detailData.international_stu_ratio || '---' }}</span></li>
                        <li><span>男女比例: </span><span>{{ detailData.gender_rate || '---' }}</span></li>
                        <li><span>就业比例: </span><span>{{ detailData.employment_rate || '---' }}</span></li>
                        <li><span>平均起薪: </span><span>{{ detailData.average_salary || '---' }}</span></li>
                        <li><span>面试形式: </span><span>{{ detailData.interview_format || '---' }}</span></li>
                    </ul>
                </div>
                <div class="title_box">
                    <div class="title_box_content" id="direction-content-title">
                        <img src="https://oss.kaoyanvip.cn/attach/file1738981959289.png" alt=""></img>
                        <span>细分方向</span>
                    </div>
                    <p v-if="detailData.directions_remarks" style="color: #8A8A8D;">{{ detailData.directions_remarks }}
                    </p>
                    <div class="table_container">
                        <el-table :data="detailData.directions" style="width: 100%;"
                            :header-cell-style="{ background: '#F6F6F8', color: '#8A8A8D' }">
                            <el-table-column align="center" type="index" label="序号" width="100px"></el-table-column>
                            <el-table-column align="center" prop="name" label="中文名称"></el-table-column>
                            <el-table-column align="center" prop="ename" label="英文名称"></el-table-column>
                        </el-table>
                    </div>
                </div>
                <div class="title_box">
                    <div class="title_box_content" id="description-content-title">
                        <div>
                            <img src="https://oss.kaoyanvip.cn/attach/file1738981959289.png" alt=""></img>
                            <span>申请要求</span>
                        </div>

                    </div>
                    <p style="color: #303030;">{{ detailData.apply_requirement || '暂无申请要求信息' }}</p>
                </div>
                <div class="title_box">
                    <div class="title_box_content applyTime">
                        <div>
                            <img src="https://oss.kaoyanvip.cn/attach/file1738981959289.png" alt=""></img>
                            <span>申请时间</span>
                        </div>
                        <el-select size="small" v-model="apply_time_value" placeholder="请选择" @change="handleChange">
                            <el-option v-for="item in detailData.apply_time"
                                :label="`${item.year}年${item.enroll_time}季入学`" :value="item.year + item.enroll_time">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="apply_time_content">
                        <div v-if="apply_types.length > 0" style="margin-bottom: 20px;background-color: #F6F6F8;"
                            v-for="type in apply_types" :key="type.label">
                            <p>{{ type.label }}</p>
                            <div class="time_line">
                                <el-timeline class="timeline">
                                    <el-timeline-item class="lineitem" v-for="(activity, index) in type.children"
                                        :key="index" :timestamp="activity.time">
                                        {{ activity.label.endsWith('截止') ? activity.label.slice(0, -2) : activity.label }}
                                        <el-tag v-if="isExpired(activity)" size="small" type="danger">已结束</el-tag>
                                    </el-timeline-item>
                                </el-timeline>
                            </div>
                        </div>
                        <div v-if="apply_types.length == 0" style="color: #8A8A8D;text-align: center;">暂无数据</div>
                    </div>
                </div>
                <div class="title_box">
                    <div class="title_box_content">
                        <img src="https://oss.kaoyanvip.cn/attach/file1738981959289.png" alt=""></img>
                        <span>语言要求</span>
                    </div>

                    <p style="color: #8A8A8D;">{{ detailData.lan_remarks }}</p>

                    <div class="table_container">
                        <el-table :data="detailData.lan_requirement" style="width: 100%;"
                            :header-cell-style="{ background: '#F6F6F8', color: '#8A8A8D' }">
                            <el-table-column align="center" prop="lan_type" label="语言项"></el-table-column>
                            <el-table-column align="center" prop="total_score" label="总分要求"></el-table-column>
                            <el-table-column v-if="hasSmallScore" align="center" prop="small_score"
                                label="小分要求"></el-table-column>
                            <template v-if="!hasSmallScore">
                                <el-table-column align="center" prop="hear_score" label="听力要求"></el-table-column>
                                <el-table-column align="center" prop="read_score" label="阅读要求"></el-table-column>
                                <el-table-column align="center" prop="write_score" label="写作要求"></el-table-column>
                                <el-table-column align="center" prop="speak_score" label="口语要求"></el-table-column>
                            </template>
                        </el-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getSchoolMajorDetail } from '@/api/college-library'
import _ from 'lodash'

export default {
    name: 'MajorDetail',
    data() {
        return {
            majorId: '',
            loading: false,
            detailData: {},
            activeName: 'introduction',
            apply_time_value: '',
            activities: [],
            apply_types: []
        }
    },
    computed: {
        hasSmallScore() {
            if (!this.detailData.lan_requirement) {
                return false;
            }
            return this.detailData.lan_requirement.some(item => item.small_score != null);
        }
    },
    created() {
        const { tabType } = this.$route.query;
        if (tabType) {
            this.activeName = tabType;
        }
        this.fetchSchoolMajorDetail()
    },
    watch: {
        detailData: {
            handler(newVal) {
                if (Object.keys(newVal).length > 0) {
                    this.$nextTick(() => {
                        this.initScrollListener();
                        if (this.$route.query.tabType) {
                            this.activeName = this.$route.query.tabType;
                            let targetId;
                            if (this.$route.query.tabType === 'introduction') {
                                targetId = 'introduce-colleges-content-title';
                            } else if (this.$route.query.tabType === 'direction') {
                                targetId = 'direction-content-title';
                            } else if (this.$route.query.tabType === 'illustrate') {
                                targetId = 'description-content-title';
                            }
                            const targetElement = document.getElementById(targetId);
                            if (targetElement) {
                                targetElement.scrollIntoView({ behavior: 'smooth' });
                            }
                        }
                    });
                }
            },
            immediate: true
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.initScrollListener();
            // 处理路由参数中的tabType
            if (this.$route.query.tabType) {
                let targetId = 'introduce-colleges-content-title';
                if (this.$route.query.tabType === 'direction') {
                    this.activeName = 'direction';
                    targetId = 'direction-content-title';
                } else if (this.$route.query.tabType === 'illustrate') {
                    this.activeName = 'illustrate';
                    targetId = 'description-content-title';
                }
                const targetElement = document.getElementById(targetId);
                if (targetElement) {
                    targetElement.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                        inline: 'nearest'
                    });
                }
            }
        });
    },
    beforeDestroy() {
        // 移除滚动事件监听器
        const scrollBox = document.querySelector('.scroll_box');
        scrollBox.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        // 获取学校专业详情
        fetchSchoolMajorDetail() {
            this.loading = true
            getSchoolMajorDetail(this.$route.params.school_major_id).then(res => {
                this.detailData = res.data
                this.loading = false
                this.apply_time_value = this.detailData.apply_time[0].year + this.detailData.apply_time[0].enroll_time
                this.apply_types = this.detailData.apply_time[0].children
            }).finally(() => {
                this.loading = false
            })
        },
        // 跳转到官网
        handleToWebsite() {
            window.open(this.detailData.project_website)
        },
        // 切换tab
        handleTabClick(tab, event) {
            if (tab.index == 0) {
                let introduceDom = document.getElementById('introduce-colleges-content-title')
                introduceDom.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                    inline: 'nearest'
                })
            } else if (tab.index == 1) {
                let directionDom = document.getElementById('direction-content-title')
                directionDom.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                    inline: 'nearest'
                })
            } else if (tab.index == 2) {
                let descriptionDom = document.getElementById('description-content-title')
                descriptionDom.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                    inline: 'nearest'
                })
            }
        },
        initScrollListener() {
            const scrollBox = document.querySelector('.scroll_box');
            if (scrollBox) {
                // 移除之前的监听器，避免重复
                scrollBox.removeEventListener('scroll', this.handleScroll);
                scrollBox.addEventListener('scroll', this.handleScroll);
            }
        },
        // 滚动事件监听器
        handleScroll: _.debounce(function () {
            const introduceDom = document.getElementById('introduce-colleges-content-title');
            const directionDom = document.getElementById('direction-content-title');
            const descriptionDom = document.getElementById('description-content-title');
            const scrollBox = document.querySelector('.scroll_box');
            const scrollTop = scrollBox.scrollTop;

            // 获取各个区域的位置
            const introduceTop = introduceDom.offsetTop;
            const directionTop = directionDom.offsetTop;
            const descriptionTop = descriptionDom.offsetTop;

            // 设置一个偏移量，使切换更平滑
            const offset = 100;

            // 根据滚动位置判断当前所在区域
            if (scrollTop >= descriptionTop - offset) {
                this.activeName = 'illustrate';
            } else if (scrollTop >= directionTop - offset) {
                this.activeName = 'direction';
            } else if (scrollTop >= introduceTop - offset) {
                this.activeName = 'introduction';
            }
        }, 100),
        // 切换时间
        handleChange(val) {
            if (!val) {
                this.apply_types = []
                return
            }
            this.apply_time_value = val
            let tempObj = this.detailData.apply_time.filter(item => item.year + item.enroll_time === val)
            this.apply_types = tempObj[0].children

        },
        isExpired(activity) {
            if(activity.label === '开放申请'){
                return false
            }
            const currentTime = new Date();
            const activityTime = new Date(activity.time);
            return activityTime < currentTime;
        },
        handleToCollege(id, tabType) {
            if (this.$store.getters.roles.includes('query.view_study_abroad_school_admin')) {
                const routeData = this.$router.resolve({
                    path: `/college-library/detail/${id}`,
                    query: {
                        tabType
                    }
                })
                window.open(routeData.href, '_blank')
            } else {
                this.$message({
                    message: '暂无相关权限',
                    type: 'warning'
                })
            }
        },
    }
}
</script>
<style lang="less" scoped>
::v-deep .el-select .el-input.is-focus .el-input__inner {
    border-color: #4678F8;
}

::v-deep .el-select .el-input__inner:focus {
    border-color: #4678F8;
}

:deep(.el-select-dropdown__item.selected) {
    color: #4678F8 !important;
}

:global(.el-select-dropdown__item.selected) {
    color: #4678F8 !important;
}
::v-deep .el-tabs__item.is-active,
::v-deep .el-tabs__item:hover {
    color: #4678f8;
    font-size: 16px;
}

::v-deep .el-tabs__item {
    font-weight: 600;
    font-size: 16px;
}

::v-deep .el-tabs__active-bar {
    background-color: #4678f8;
}

::v-deep .el-table {
    .el-table__body {
        td {
            color: #181818;
        }
    }
}

.major_detail_container {
    flex: 1;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    background-color: #f7f7f8;

    .breadcrumb_box {
        margin: 16px 0 0 16px;

        ::v-deep .el-breadcrumb__inner.is-link:hover {
            color: #4678f8;
        }
    }

    .school_major_info {
        display: flex;
        justify-content: space-between;
        margin: 16px 16px 0;
        padding: 16px;
        background-color: #fff;
        border-radius: 4px;

        .logo-section {
            flex: 1;
            display: flex;
            align-items: center;

            img {
                width: 80px;
                height: 80px;
                margin-right: 16px;
                border-radius: 4px;
            }

            .school_name {
                font-size: 20px;
                color: #303030;
                font-weight: 600;
            }

            .e_name {
                font-size: 16px;
                margin: 10px 0 0 0;
            }

            .el-link.el-link--default:hover {
                color: #4678F8;
            }

            .school_address {
                margin-top: 10px;
                color: #8A8A8D;
                font-size: 14px;

                i {
                    margin-right: 10px;
                }
            }
        }

        .rankings-section {
            flex: 1;
            display: flex;
            gap: 10px;
            justify-content: center;
            padding: 20px;
        }

        .ranking-item {
            background-color: #fff;
            border-radius: 16px;
            text-align: center;
            width: 240px;
            height: 108px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            background-size: cover;
            background-position: center;

            &:nth-child(1) {
                color: #D07AF5;
                /* 背景图片居中铺满 */
                background-image: url('https://oss.kaoyanvip.cn/attach/file1738981959467.png');
            }

            &:nth-child(2) {
                color: #FF6528;
                /* 背景图片居中铺满 */
                background-image: url('https://oss.kaoyanvip.cn/attach/file1738983925203.png');
            }

            &:nth-child(3) {
                color: #29BFFE;
                /* 背景图片居中铺满 */
                background-image: url('https://oss.kaoyanvip.cn/attach/file1738981959653.png');
            }
        }

        .ranking-item span {
            margin: 10px 0;
            font-size: 14px;
            color: #8A8A8D;
        }

        .ranking-item p {
            margin: 0;
            font-size: 24px;
            font-weight: bold;
        }

        .tags {
            display: flex;
            gap: 8px;
            margin-top: 10px;

            .tag_item {
                color: #53BC6B;
                padding: 3px 10px;
                font-size: 14px;
                background-color: #EDF8F0;
                border-radius: 4px;
            }
        }
    }

    .content {
        flex: 1;
        padding: 10px 20px 20px 20px;
        margin: 16px;
        background-color: #fff;
        border-radius: 4px;
        box-sizing: border-box;
        position: relative;

        .scroll_box {
            width: 99%;
            height: calc(100% - 84px);
            overflow: auto;
            position: absolute;
            padding-right: 20px;

            .table_container {
                overflow: hidden;
                border: 1px solid #eeeeee;
                border-radius: 8px;

                ::v-deep .el-table tr:last-child td {
                    border-bottom-color: transparent;
                }

                ::v-deep .el-table::before {
                    height: 0 !important;
                }
            }
        }

        .title_box {
            margin-top: 15px;

            &_content {
                font-size: 18px;
                color: #303030;
                font-weight: 600;
                margin-bottom: 10px;

                img {
                    margin-right: 10px;
                }
            }

            .applyTime {
                display: flex;
                justify-content: space-between;
            }

            .apply_time_content {
                border-radius: 4px;
                overflow: auto;

                p {
                    margin: 0;
                    padding: 20px 0 20px 20px;
                    border-bottom: 1px solid #E6E6E6;
                    font-size: 16px;
                    font-weight: 600;
                }

                .time_line {
                    padding: 80px 90px 80px;
                    overflow: hidden;

                    .timeline {
                        display: flex;
                        padding: 0;
                        justify-content: center;

                        .lineitem {
                            transform: translateX(50%);
                            width: 100px;

                            .el-tag {
                                color: #FB4E59;
                                background-color: #FEEDEE;
                            }
                        }
                    }

                    ::v-deep .el-timeline-item__tail {
                        border-left: none;
                        border-top: 2px solid #4678F8;
                        width: 100%;
                        position: absolute;
                        top: 6px;
                    }

                    ::v-deep .el-timeline-item__wrapper {
                        padding-left: 0;
                        position: absolute;
                        top: 20px;
                        transform: translateX(-50%);
                        text-align: center;
                    }

                    ::v-deep .lineitem {
                        width: 280px !important;
                    }

                    ::v-deep .el-timeline-item__node {
                        background-color: #4678F8; // 时间点颜色
                        border: 2px solid #fff; // 白色外边框
                        width: 12px; // 调整时间点大小
                        height: 12px; // 调整时间点大小
                    }

                    ::v-deep .el-timeline-item__content {
                        position: relative;

                        .el-tag {
                            position: absolute;
                            top: 50%;
                            right: 0;
                            transform: translate(100%, -50%);
                        }
                    }
                }
            }
        }


        .projectIntroduction {
            padding: 20px;
            list-style: none;
            display: flex;
            flex-wrap: wrap;
            gap: 10px;
            background-color: #F6F6F8;
            border-radius: 4px;

            li {
                width: 240px;
                line-height: 30px;
                white-space: nowrap;
                /* 防止文本换行 */
                overflow: hidden;
                /* 隐藏超出部分 */
                text-overflow: ellipsis;

                /* 显示省略号 */
                span {
                    font-size: 16px;

                    &:first-child {
                        color: #8A8A8D;
                    }

                    &:last-child {
                        font-weight: 500;
                    }
                }
            }
        }

        .text_info {
            font-size: 16px;
            color: #303030;
            line-height: 1.5;
        }
    }
}
</style>
